import { Component, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { LibraryList, LibraryListTypes } from '../../reducers/library-list.reducer';
import { faBookReader } from '@fortawesome/pro-solid-svg-icons';
import { faUser } from '@fortawesome/pro-light-svg-icons';
import { Store } from '@ngrx/store';
import { runSavedSearch } from 'app/saved-search/actions/saved-search.actions';

import { CustomShowcaseCreatedFromType } from 'app/custom-showcase/models/custom-showcase';
import { FeatureToggleService } from 'app/services/feature-toggle.service';

@Component({
  selector: 'app-library-list-header',
  templateUrl: './library-list-header.component.html',
  styleUrls: ['./library-list-header.component.scss'],
})
export class LibraryListHeaderComponent implements OnDestroy, OnInit {
  @Input() public libraryList: LibraryList;
  @Input() public itemsCount: number;
  @Output() public searchTermChanged = new EventEmitter<string>();
  @Input() public libraryListType: LibraryListTypes;
  @Input() public libraryCreatedFrom: CustomShowcaseCreatedFromType | null;

  public searchTerm: string = '';
  public readonly bookReaderIcon = faBookReader;
  public readonly userIcon = faUser;
  public readonly LibraryListTypes = LibraryListTypes;
  public readonly CustomShowcaseCreatedFromType = CustomShowcaseCreatedFromType;
  public isSearchShowcaseEnabled: boolean;
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly featureToggleService: FeatureToggleService,
    private readonly store: Store
  ) {}
  public runSavedSearch(): void {
    this.store.dispatch(
      runSavedSearch({ savedSearchId: this.libraryList.createdFrom.id })
    );
  }

  public ngOnInit() {
    this.isSearchShowcaseEnabled = this.featureToggleService.getToggles()['DIS-32415_10-31-24_showcase-search'];
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public onSearchTermChange(): void {
    this.searchTermChanged.emit(this.searchTerm);
  }
}
